import { useCallback } from 'react';
import { getURLParams } from 'js/utils/url.util';

import { useNavigate } from './useNavigate';

export const useRemoveQueryParams = () => {
    const navigateWithReplace = useNavigate({ replace: true });

    return useCallback(paramsToRemove => {
        const paramsFromURL = getURLParams(location.search);
        const removeParams = paramsToRemove.filter((param) => paramsFromURL[param] !== undefined);

        removeParams.length && navigateWithReplace(location, history.state?.state, { removeParams, preserveHash: true });
    }, [navigateWithReplace]);
};
